<script setup>
import { useAuth } from '@/stores/auth.js'
import { push, ref as fref, serverTimestamp, set } from 'firebase/database'
import { database } from '@/firebase.js'
import { notNull } from '@/rules.js'
import { ref } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const auth = useAuth()
const isFormValid = ref(false)
const title = ref()
const emits = defineEmits(['onSave'])

const onFormSubmit = async () => {
  if (!isFormValid.value) {
    return
  }

  const newRoom = push(fref(database, 'rooms'))

  await set(newRoom, {
    owner: auth.id,
    created_at: serverTimestamp(),
    started: false,
    activeStory: null
  }).then(async () => {
    await router.push({ name: 'room', params: { id: newRoom.key } })
    emits('onSave')
  })
}
</script>

<template>
  <v-form v-model="isFormValid" @submit.prevent="onFormSubmit">
    <v-text-field
      v-model="title"
      :rules="[notNull]"
      density="comfortable"
      label="Pick an room title"></v-text-field>
    <v-btn class="mt-8" block type="submit">Create Room</v-btn>
  </v-form>
</template>

<style scoped></style>
